import React, { useCallback } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { defineMessages } from 'react-intl';
import { useSelector } from 'react-redux';

import { DefaultPlaceholder } from 'ui-components/components/display-grid/default-placeholder';

import Global from '../../../../store/global-selectors';

import Placeholders from './placeholders';

const sharedMessages = defineMessages({
  buttonContent: {
    description: 'ordersGridPlaceholder.buttonContent',
    defaultMessage: 'Connect a Store',
    id: 'RJsyB+',
  },
  actionDescription: {
    description: 'ordersGridPlaceholder.actionDescription',
    defaultMessage: 'Connect your stores and marketplaces to manage all your orders in one place.',
    id: 'MzVHHS',
  },
});

const OrdersGridPlaceholder = () => {
  const hasStoreConnected = useSelector((state) => !Global.selectSellerStores(state).every(({ isManualStore }) => isManualStore));
  const hasFiltersApplied = useSelector((state) => {
    const { appliedFilters = [] } = Global.selectOrdersFilteringActiveFilterView(state);
    return !!appliedFilters.length;
  });
  const history = useHistory();
  const { statusViewId, storeGuid } = useParams();
  const storeName = useSelector((state) => {
    if (storeGuid) {
      return Global.selectSellerStoreData(state, { storeGuid })?.name;
    }
  });
  const action = useCallback(() => {
    history.push('/settings/stores');
  }, [history]);

  const PlaceholderComponent = hasFiltersApplied ? Placeholders.filtering : Placeholders[statusViewId];

  return PlaceholderComponent ? (
    <PlaceholderComponent
      action={action}
      hasStoreConnected={hasStoreConnected}
      history={history}
      sharedMessages={sharedMessages}
      storeName={storeName}
    />
  ) : (
    <DefaultPlaceholder />
  );
};

export default OrdersGridPlaceholder;
